import m from "../../../../geodata/es2015/region/usa/ohHigh";
window.am4geodata_region_usa_ohHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/ohHigh.js
// module id = null
// module chunks = 